import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import RegisterView from '@/views/RegisterView.vue';
import SignupView from '@/views/SignupView.vue';
import SignInView from '@/views/SignInView.vue';
import CallbackView from '@/views/CallbackView.vue';
import ForgotPasswordView from '@/views/ForgotPasswordView.vue';
import ResetPasswordView from '@/views/ResetPasswordView.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/signin',
  },
  // /login removido — el único entry point de auth es /signin (SignInView
  // con email+password+Google). Redirigimos por compatibilidad con enlaces
  // antiguos (emails de verificación, deeplinks, etc.).
  {
    path: '/login',
    redirect: (to) => ({ path: '/signin', query: to.query }),
  },
  {
    // Sign-in: email + password + Google. Entry point de la auth-frontend.
    path: '/signin',
    name: 'Signin',
    component: SignInView,
  },
  {
    // Signup hero. Email field + CTA; submit hands off to /register.
    path: '/signup',
    name: 'Signup',
    component: SignupView,
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView,
  },
  {
    path: '/callback',
    name: 'Callback',
    component: CallbackView,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// SPA page_view for GA4 on every route change (PostHog tracks pageviews itself)
router.afterEach((to) => {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', 'page_view', { page_path: to.fullPath, page_title: document.title });
  }
});

export default router;
